import { observer } from "mobx-react-lite"
import { store } from "../../../stores/Store"
import { useEffect } from "react"
import ReportTable from "./ReportTable"
import { Button, IconButton } from "@mui/material"
import { Icons } from "../../../misc/Icons"
import PanelHeader from "../../layout/PanelHeader"
import PanelBody from "../../layout/PanelBody"
import { DisplayValue } from "../../.."


export default observer(function ReportTool() {
    
    const { getReports, searchString, setSearchString } = store.ReportStore
    const { setTool } = store.ToolStore

    useEffect(() => {
        if (!store.ReportStore.reports?.length) {
            getReports()
        }
    }, [])

    return (
        <div className="panel panel-dark">
            <PanelHeader>
                <div style={{display: "flex", gap: "10px", flexFlow: "wrap", alignItems: "center"}}>
                    <h2>Reports</h2>

                    <div className="form-search form-search-dark">
                        <input 
                            autoFocus 
                            value={searchString}
                            placeholder="Search"
                            spellCheck="false"
                            onChange={(e) => {
                                setSearchString(e.target.value)
                            }} />
                        
                        {/* <Button
                            color="info"
                            className="btn btn-sm"
                            onClick={() => getReports()}>
                            <Icons.Refresh style={{color: "white"}} />
                        </Button> */}
                    </div>

                    <Button
                        color="secondary"
                        variant="contained"
                        className="btn btn-sm"
                        onClick={() => getReports()}>
                        <Icons.Refresh /> Refresh
                    </Button>
                </div>

                <IconButton color="secondary" style={{margin: "0 0 auto auto"}} size="small" onClick={() => store.ToolStore.setTool(null)}><Icons.X /></IconButton>
            </PanelHeader>
            
            <PanelBody>
                <ReportTable />
            </PanelBody>
        </div>
    )
})